
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Fiyat Düzenle</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Fiyat</h4>
          <v-text-field v-model="subscriptionPlanData.amount" maxlength="255" type="number" counter="255" :rules="subscriptionPlanAmountRule" required></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            color="#4d48f9"
            style="margin-top: 10px; color: white;"
            @click="subscriptionPlanUpdate()"
          >GÜNCELLE
          </v-btn
          >
        </v-col>
      </v-row>

      <v-dialog
        v-model="dialog"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">Lütfen alanları kontrol edin</v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{fruit}}</li>
            </ul>
          </v-card-text>

        </v-card>
      </v-dialog>

      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';

export default {
  name: "SubscriptionPlanDetail",
  data: () => ({
    valid: true,
    subscriptionPlanAmountRule: [v => !!v || "Fiyat girilmesi zorunludur.",
      v => /^\d+$/.test(v) || 'Sadece sayı girilmelidir.'],
    errorList:[],
    dialog:false
  }),
  computed:mapGetters(['subscriptionPlanData']),
  created() {
    let subscriptionPlan={
      id:this.$route.params.id
    }
    this.getSubscriptionPlan(subscriptionPlan);
  },
  methods: {
    ...mapActions(["getSubscriptionPlan","updateSubscriptionPlanAmount"]),
    routesubscriptionPlans() {
      this.$router.push("/dashboard/subscriptionPlans");
    },
    subscriptionPlanUpdate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.updateSubscriptionPlanAmount(this.subscriptionPlanData).then(response=>{
          if(response.processStatus == "Success") {
            this.routesubscriptionPlans();
          }
          else {
            alert("Bir hata oluştu");
          }
        }).catch(err=>{
          alert(err);
        })
      }else{
        var errors=[];
        var x = document.getElementsByClassName("v-messages__message");
        for (var i = 0; i < x.length; i++)
          errors.push(x[i].innerHTML);

        this.errorList=errors;

        this.dialog=true;
      }
    }
  },
};
</script>
